import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "lightIntensity";
const UNIT = "lux";

const LightIntensity: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default LightIntensity;